import React from "react";

const ArrowDownIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_220_27296)">
        <path
          d="M16.9498 19.3635C17.5021 19.3635 17.9498 18.9158 17.9498 18.3635C17.9498 17.8112 17.5021 17.3635 16.9498 17.3635L8.05033 17.3635L19.0711 6.34269C19.4617 5.95216 19.4617 5.319 19.0711 4.92847C18.6806 4.53795 18.0475 4.53795 17.6569 4.92847L6.63612 15.9493L6.63612 7.04979C6.63612 6.49751 6.1884 6.04979 5.63612 6.04979C5.08383 6.04979 4.63612 6.49751 4.63612 7.04979L4.63612 18.3635C4.63611 18.9158 5.08383 19.3635 5.63612 19.3635L16.9498 19.3635Z"
          fill="#646F87"
        />
      </g>
      <defs>
        <clipPath id="clip0_220_27296">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ArrowDownIcon;
